(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["in-page-content_form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // need to maintain parent container height when form is submitted otherwise it will collapse and it looks bad
  // give it some time to load and then get the height
  let ipcfWrapHeight = null;
  setTimeout(function() {
    const ipcfWrap = document.querySelector('.ipcf-wrap');
    if (ipcfWrap) {
      ipcfWrapHeight = ipcfWrap.offsetHeight;
    }
  }, 1500);
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn') && e.target.classList.contains('btn-primary') && e.target.type === 'submit') {
      if (ipcfWrapHeight !== null && window.innerWidth > 768) {
        const ipcfWrap = document.querySelector('.ipcf-wrap');
        if (ipcfWrap) {
          ipcfWrap.style.height = ipcfWrapHeight + 'px';
        }
      }
      
      const observer = new MutationObserver(function(mutations, obs) {
        const submittedMessage = document.querySelector('.submitted-message');
        if (submittedMessage) {
          obs.disconnect();
          
          submittedMessage.remove();
          
          const formWrap = document.querySelector('.ipcf-form-wrap');
          if (formWrap) {
            formWrap.classList.add('hidden');
          }
          
          const submitted = document.querySelector('.ipcf-submitted');
          if (submitted) {
            submitted.classList.add('active');
          }
          
          // Scroll to top of form on mobile
          if (window.innerWidth <= 768) {
            const ipcfWrap = document.querySelector('.ipcf-wrap');
            if (ipcfWrap) {
              const rect = ipcfWrap.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetY = rect.top + scrollTop - 150;
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
        }
      });
      
      const formContainer = document.querySelector('.ipcf-form');
      if (formContainer) {
        observer.observe(formContainer, {
          childList: true,
          subtree: true
        });
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megalinks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const headers = document.querySelectorAll('.link-columns_header[data-toggle]');

headers.forEach(header => {
header.addEventListener('click', function() {
const targetId = this.getAttribute('data-toggle');
const targetList = document.getElementById(targetId);
const isOpen = targetList.classList.contains('is-open');

// Toggle dropdown visibility
if (isOpen) {
targetList.classList.remove('is-open');
this.classList.remove('is-open');
} else {
targetList.classList.add('is-open');
this.classList.add('is-open');
}
});
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-and-compliance"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function listSize() {
      return $('li.filterhead.tab-active').length;
    }

    function activeItemsCount() {
      return $('li.filterhead.tab-active:visible').length;
    }

    function hasMoreItems() {
      return listSize() > activeItemsCount();
    }

    function showAll() {
      $('.filterhead').each().addClass('tab-active');
      $('.filterhead').each().show();
    }

    function sortList() {
      var $ul = $('#product-list');
      var listitems = $ul.children('li').get();

      listitems.sort(function(a, b) {
        // Get text content and convert to uppercase for case-insensitive sorting
        var compA = $(a.firstElementChild).text().toUpperCase();
        var compB = $(b.firstElementChild).text().toUpperCase();
        
        // Comparison logic
        if (compA < compB) {
            return -1; // a comes first
        }
        if (compA > compB) {
            return 1; // b comes first
        }
        return 0; // they are equal
      });

      // Re-append the sorted items to the parent ul
      $.each(listitems, function(idx, itm) {
          $ul.append(itm);
      })
    }

    function resetListSize() {
      $('li.filterhead').hide();
      $('li.filterhead.tab-active').slice(0, 15).show();
      toggleLoadButton();
    }

    function toggleLoadButton() {
      if (hasMoreItems()) {
        $('#load_more').show();
        $('#return_top').hide();
      } else {
        $('#load_more').hide();
        $('#return_top').show();
      }
    }

    function roundTo15s(num) {
      return Math.ceil(num / 15) * 15;
    }

    function increaseListSize() {
      const items = activeItemsCount();
      if (items < listSize()) {
        $('li.filterhead.tab-active')
          .slice(0, roundTo15s(items + 1))
          .show();
      }
      toggleLoadButton();
    }

    const loadMoreButton = document.getElementById('load_more');
    
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', increaseListSize);
    }

    resetListSize();

    $('#search_lot').on('submit', function (e) {
      e.preventDefault();
    });

    //Search Logic
    $('#search_lot').on('input', function (e) {
      e.preventDefault();
      
      var value = $('#myInput').val().toLowerCase();
      if (value != '') {
        $('.dtect').html('Search Results');
        $('.filterhead').each(function () {
          $(this).hide();
          $(this).removeClass('tab-active');
          if ($(this).attr('data-class').toLowerCase().indexOf(value) > -1) {
            $(this).addClass('tab-active');
            $(this).show();
          }

          $('#load_more').hide();
        });
        $('#empty-search').text('');
        $('#clear_search_results').show();
      } else {
        $('.dtect').html('All Products');
        $('.filterhead').show().addClass('tab-active');
      }
      $('.blog-count span').html($('.filterhead.tab-active').length);
      resetListSize();
    });
    //End Search Logic

    $('#myInput').val('');
    var value = $('#myInput').val().toLowerCase();

    //Filter Logic
    $('#headinggrid *').filter(function () {
      if ($(this).text().toLowerCase().indexOf(value) > -1) {
        $(this).siblings('.sub-heading').slideUp();
      }
      $('.heading').find('i').removeClass('fa-caret-down');
      $('.heading').find('i').addClass('fa-caret-right');
      $('.heading').find('a').removeClass('active');
    });
    $('#clear_search_results').hide();
    $('#search_lot').trigger('submit');
    resetListSize();

    $('body').on('click', '.faq-list li a', function () {
      var texxt = $(this).html();
      $('.dtect').html(texxt);
      var target = $(this).attr('data-tag');
      $('.faq-list li a').removeClass('active');
      $(this).addClass('active');
      $('.filterhead').removeClass('tab-active');
      $("li[data-tags='" + $(this).attr('data-tag') + "']").addClass('tab-active');
      $("li[data-tags='" + $(this).attr('data-tag') + "']").show();

      var numItems = $("li[data-tags='" + $(this).attr('data-tag') + "']").length;

      if (target.toLowerCase() === 'all') {
        $('.filterhead').addClass('tab-active');
        $('.filterhead').show();
        numItems = $('.mylist > li').length;
      }

      $('.blog-count span').html(numItems);

      resetListSize();
      toggleLoadButton();
      //End Filter Logic
    });
    sortList();
    resetListSize();
  });

  } catch(e) { console.error(e); }
})();
})();
